import { render, staticRenderFns } from "./ExistingUserV2.vue?vue&type=template&id=5656a2ea&"
import script from "./ExistingUserV2.vue?vue&type=script&lang=js&"
export * from "./ExistingUserV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports